export const DEEPLINK_MAP = {
  'printer-details': '/printers',
  'smart-security': '/solutions/smartsecurity',
  'users-invite': '/users/invite',
};

export const HP_SMB_APP_SCHEMA = 'hpdl';
